"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var reactive_google_map_1 = require("@dotdev/reactive-google-map");
var __1 = require("../");
/** [[include:component/click-and-collect-map.md]] */
var ClickAndCollectMap = /** @class */ (function (_super) {
    __extends(ClickAndCollectMap, _super);
    function ClickAndCollectMap() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleChangeBounds = function (bounds) {
            _this.context.clickAndCollect.updateQuery({
                position: _this.context.clickAndCollect.googleMapClient.mapGetCenter(),
            });
        };
        return _this;
    }
    ClickAndCollectMap.prototype.render = function () {
        return (React.createElement(reactive_google_map_1.GoogleMap, __assign({ googleMapsApiVersion: this.context.clickAndCollect.options.googleMapsApiVersion, googleMapsApiKey: this.context.clickAndCollect.options.googleMapsApiKey, callback: this.context.clickAndCollect.setGoogleMapClient, mapOnClick: this.context.clickAndCollect.selectClear, mapOnBoundsChange: this.handleChangeBounds, markersOnClick: this.context.clickAndCollect.selectMarker, infowindowMaxWidth: 300, infowindowOnClose: this.context.clickAndCollect.selectClear, infowindowContent: function (marker) { return (React.createElement(React.Fragment, null,
                "Marker ",
                marker.id)); }, markers: this.context.clickAndCollect.markers }, this.props)));
    };
    ClickAndCollectMap.contextType = __1.Context;
    return ClickAndCollectMap;
}(React.Component));
exports.ClickAndCollectMap = ClickAndCollectMap;
//# sourceMappingURL=click-and-collect-map.js.map